module.exports = __webpack_public_path__ + "media/bootstrap-icons/dash-circle-fill-76250f94.svg";